import {
    DELETE_ALL_USER_SHOWCASE_FAILED,
    DELETE_ALL_USER_SHOWCASE_START,
    DELETE_ALL_USER_SHOWCASE_SUCCESS,
    DELETE_USER_SHOWCASE_FAILED,
    DELETE_USER_SHOWCASE_START,
    DELETE_USER_SHOWCASE_SUCCESS,
    FETCH_USER_SHOWCASE_FAILED,
    FETCH_USER_SHOWCASE_FAILED_ID,
    FETCH_USER_SHOWCASE_START,
    FETCH_USER_SHOWCASE_START_ID,
    FETCH_USER_SHOWCASE_SUCCESS,
    FETCH_USER_SHOWCASE_SUCCESS_ID,
    UPLOAD_USER_SHOWCASE_FAILED,
    UPLOAD_USER_SHOWCASE_START,
    UPLOAD_USER_SHOWCASE_SUCCESS,
    UPDATE_SHOWCASE_VISIBILITY,
    UPDATE_SHOWCASE_VISIBILITY_FAILED,
    UPDATE_SHOWCASE_VISIBILITY_SUCCESS,
    REQUEST_VISIBILITY_SHOWCASE,
    REQUEST_VISIBILITY_SHOWCASE_SUCCESS,
    REQUEST_VISIBILITY_SHOWCASE_FAILED,
    APPROVED_VISIBILITY_SHOWCASE,
    APPROVED_VISIBILITY_SHOWCASE_SUCCESS,
    APPROVED_VISIBILITY_SHOWCASE_FAILED,
    DECLINE_VISIBILITY_SHOWCASE,
    DECLINE_VISIBILITY_SHOWCASE_SUCCESS,
    DECLINE_VISIBILITY_SHOWCASE_FAILED

} from "./ActionConstant";

// Add user showcase actions
export function uploadShowcaseMediaStart(payload) {
    return {
        type: UPLOAD_USER_SHOWCASE_START,
        payload,
    };
}

export function uploadShowcaseMediaSuccess(payload) {
    return {
        type: UPLOAD_USER_SHOWCASE_SUCCESS,
        payload,
    };
}

export function uploadShowcaseMediaFailure(payload) {
    return {
        type: UPLOAD_USER_SHOWCASE_FAILED,
        payload,
    };
}

// Fetch user showcase actions
export function fetchUserShowcaseStart() {
    return {
        type: FETCH_USER_SHOWCASE_START,
    };
}

export function fetchUserShowcaseSuccess(payload) {

    return {
        type: FETCH_USER_SHOWCASE_SUCCESS,
        payload,
    };
}

export function fetchUserShowcaseFailure(payload) {
    return {
        type: FETCH_USER_SHOWCASE_FAILED,
        payload,
    };
}


// Delete user showcase actions
export function deleteUserShowcaseStart(payload) {
    return {
        type: DELETE_USER_SHOWCASE_START,
        payload,
    };
}

export function deleteUserShowcaseSuccess(payload) {

    return {
        type: DELETE_USER_SHOWCASE_SUCCESS,
        payload,
    };
}

export function deleteUserShowcaseFailure(payload) {
    return {
        type: DELETE_USER_SHOWCASE_FAILED,
        payload,
    };
}

// Update showcase visibility actions
export function updateShowcaseVisibility(data, params) {
    return {
        type: UPDATE_SHOWCASE_VISIBILITY,
        data,
        params
    };
}


export function updateShowcaseVisibilitySuccess(payload) {
    return {
        type: UPDATE_SHOWCASE_VISIBILITY_SUCCESS,
        payload,
    };
}

export function updateShowcaseVisibilityFailure(payload) {
    return {
        type: UPDATE_SHOWCASE_VISIBILITY_FAILED,
        payload,
    };
}

// Request Visibility user showcase actions
export function requestVisibilityShowcase(payload) {
    return {
        type: REQUEST_VISIBILITY_SHOWCASE,
        payload
    };
}


export function requestVisibilityShowcaseSuccess(payload) {
    return {
        type: REQUEST_VISIBILITY_SHOWCASE_SUCCESS,
        payload,
    };
}

export function requestVisibilityShowcaseFailure(payload) {
    return {
        type:REQUEST_VISIBILITY_SHOWCASE_FAILED,
        payload,
    };
}

// Approved Visibility user showcase actions
export function approvedVisibilityShowcase(payload) {
    return {
        type: APPROVED_VISIBILITY_SHOWCASE,
        payload
    };
}


export function approvedVisibilityShowcaseSuccess(payload) {
    return {
        type: APPROVED_VISIBILITY_SHOWCASE_SUCCESS,
        payload,
    };
}

export function approvedVisibilityShowcaseFailure(payload) {
    return {
        type: APPROVED_VISIBILITY_SHOWCASE_FAILED,
        payload,
    };
}

// Decline Visibility user showcase actions
export function visibilityDeclineShowcase(payload) {
    return {
        type: DECLINE_VISIBILITY_SHOWCASE,
        payload
    };
}


export function visibilityDeclineShowcaseSuccess(payload) {
    return {
        type: DECLINE_VISIBILITY_SHOWCASE_SUCCESS,
        payload,
    };
}

export function visibilityDeclineShowcaseFailure(payload) {
    return {
        type: DECLINE_VISIBILITY_SHOWCASE_FAILED,
        payload,
    };
}
// Delete all user showcases actions
export function deleteAllUserShowcaseStart() {
    return {
        type: DELETE_ALL_USER_SHOWCASE_START,
    };
}

export function deleteAllUserShowcaseSuccess() {
    return {
        type: DELETE_ALL_USER_SHOWCASE_SUCCESS,
    };
}

export function deleteAllUserShowcaseFailure(payload) {
    return {
        type: DELETE_ALL_USER_SHOWCASE_FAILED,
        payload,
    };
}
// Fetch user showcase by id
export function fetchUserShowcaseStartById(payload) {
    return {
        type: FETCH_USER_SHOWCASE_START_ID,
        payload
    };
}

export function fetchUserShowcaseSuccessById(payload) {

    return {
        type: FETCH_USER_SHOWCASE_SUCCESS_ID,
        payload,
    };
}

export function fetchUserShowcaseFailureById(payload) {
    return {
        type: FETCH_USER_SHOWCASE_FAILED_ID,
        payload,
    };
}
